export const topSection = {
  carouselImages: {
    keys: [
      'imagem_1',
      'imagem_2',
      'imagem_3'
    ],
    hash: "QmFubmVyTW9uIEp1biAyNyAyMDIyIDEyOjQ2OjU2IEdNVC0wMzAwIChIb3LhcmlvIFBhZHLjbyBkZSBCcmFz7WxpYSk=",
  },
  welcomeContent: {
    keys: ['logo'],
    hash: 'QmFubmVyTW9uIEp1biAyNyAyMDIyIDEyOjQ0OjEzIEdNVC0wMzAwIChIb3LhcmlvIFBhZHLjbyBkZSBCcmFz7WxpYSk='
  },
  socialLinks: {
    keys: [],
    hash: 'UmVkZXMgU29jaWFpc01vbiBKdW4gMjcgMjAyMiAxNDowNjoyMSBHTVQtMDMwMCAoSG9y4XJpbyBQYWRy428gZGUgQnJhc1saWEp'
  }    
};

export const pageSection = {
  content: {
    keys: ['imagem'],
    hash: 'Q29udGX6ZG9zTW9uIEp1biAyNyAyMDIyIDEyOjU3OjIyIEdNVC0wMzAwIChIb3LhcmlvIFBhZHLjbyBkZSBCcmFz7WxpYSk='
  },
  links: {
    keys: [],
    hash: "Q2FyZOFwaW9Nb24gSnVuIDI3IDIwMjIgMTM6NDg6NTEgR01ULTAzMDAgKEhvcuFyaW8gUGFkcuNvIGRlIEJyYXPtbGlhKQ=="
  },
};

export const pageConfigSection = {
  pageConfig: {
    keys: [],
    hash: 'Q29uZmlndXJh5NvIGRhIHDhZ2luYUZyaSBKdWwgMDEgMjAyMiAxMDowNDo1NCBHTVQtMDMwMCAoSG9y4XJpbyBQYWRy428gZGUgQnJhc1saWEp'
  }
}

export const highlightsSection = {
  title: {
    keys: [],
    hash: 'VGl0dWxvTW9uIEp1biAyNyAyMDIyIDEzOjU5OjA5IEdNVC0wMzAwIChIb3LhcmlvIFBhZHLjbyBkZSBCcmFz7WxpYSk=',
  },
  tabs: {
    keys: ['imagem'],
    hash: 'UHJpbWVpcmEgQWJhTW9uIEp1biAyNyAyMDIyIDEzOjU5OjA5IEdNVC0wMzAwIChIb3LhcmlvIFBhZHLjbyBkZSBCcmFz7WxpYSk=',
  },
  dishes: {
    keys: [],
    hash: 'UHJhdG9zTW9uIEp1biAyNyAyMDIyIDEzOjU5OjA5IEdNVC0wMzAwIChIb3LhcmlvIFBhZHLjbyBkZSBCcmFz7WxpYSk=',
  }
};

export const footerSection = {
  footer: {
    keys: ['logo'],
    hash: 'Um9kYXDpTW9uIEp1biAyNyAyMDIyIDE0OjA1OjAyIEdNVC0wMzAwIChIb3LhcmlvIFBhZHLjbyBkZSBCcmFz7WxpYSk='
  }
};

export const menuSection = {
  menu: {
    keys: ['cardápio'],
    hash:'Q2FyZOFwaW9Nb24gSnVuIDI3IDIwMjIgMTU6NTk6NDggR01ULTAzMDAgKEhvcuFyaW8gUGFkcuNvIGRlIEJyYXPtbGlhKQ=='
  }
};

export const gallerySection = {
  gallery: {
    keys: [],
    hash: 'R2FsZXJpYUZyaSBKdWwgMDEgMjAyMiAxMDowNDo1NCBHTVQtMDMwMCAoSG9y4XJpbyBQYWRy428gZGUgQnJhc1saWEp'
  }
}
